<template>
  <div>
    Hey we are working on it. Come back soon and we promise to get forgot password configured.
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
